<template>
  <v-row no-gutters align="center" class="content-header">
    <v-expand-x-transition>
      <div v-show="!areFiltersOpened">
        <v-btn class="n-white-btn n-small-btn pr-4 mr-3" @click="openFilters">
          <v-icon small left class="mr-2">filter_list</v-icon>
          Filtrer
        </v-btn>
      </div>
    </v-expand-x-transition>
    <v-icon small color="accent" class="mr-2 font-weight-bold">view_stream</v-icon>
    <span class="font-weight-bold primary--text">Interventions</span>
    <v-spacer></v-spacer>
    <div class="mr-3">
      <layouts-btn />
    </div>
    <div class="mr-3">
      <list-params-btn />
    </div>
    <pager @change="changePager()" />
    <v-btn class="n-white-btn n-small-btn n-icon-btn ml-2" @click="refresh">
      <v-icon small class="accent--text font-weight-bold">refresh</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import Pager from '@/components/Interventions/Pager.vue';
import LayoutsBtn from '@/components/Interventions/LayoutsBtn.vue';
import ListParamsBtn from '@/components/Interventions/ListParamsBtn.vue';

export default {
  components: {
    Pager,
    LayoutsBtn,
    ListParamsBtn,
  },

  data: () => ({
    isOpened: true,
  }),

  props: {
    areFiltersOpened: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapState(`ui/interventions`, [
      `sorts`,
      `sortId`,
    ]),
    currentSort: {
      get() { return this.$store.getters[`ui/interventions/currentSort`]; },
      set(sort) { this.$store.commit(`ui/interventions/SET_SORT_ID`, sort.id); },
    },
    currentNbItemsPerPage: {
      get() { return this.$store.getters[`ui/interventions/currentNbItemsPerPage`]; },
      set(nbItemsPerPage) { this.$store.commit(`ui/interventions/SET_NB_ITEMS_PER_PAGE`, nbItemsPerPage); },
    },
  },

  methods: {
    openFilters() {
      this.$emit(`filters:open`);
    },
    changePager() {
      this.$emit(`pager:change`);
    },
    refresh() {
      this.$emit(`refresh`);
    },
  },

  beforeMount() {
    this.isOpened = false;
  },
};
</script>

<style lang="scss">
</style>
